var map = {
	"./access_legend.png": 152,
	"./agriculture_legend.png": 153,
	"./aoi_legend.png": 154,
	"./exampleLegend1.png": 155,
	"./exampleLegend2.png": 156,
	"./exampleLegend3.png": 157,
	"./exampleLegend4.png": 158,
	"./herders_legend.png": 159,
	"./legend.psd": 160,
	"./lulc_legend.png": 161,
	"./mines_legend.png": 162,
	"./nationalParksLegend.png": 163,
	"./nightlight_legend.png": 164,
	"./railways_legend.png": 165,
	"./roads_legend.png": 166,
	"./urban_legend.png": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;